import React, {
  useState,
  useEffect
} from "react";
import {
  MixedWidget,
  ListsWidget,
  BrandWidget,
  FoundWidget,
  InspectWidget,
  QuickViewWidget
} from "../widgets";
import {
  gql,
  useQuery
} from '@apollo/client';
import {
  useSelector,
  shallowEqual
} from "react-redux";
const API_URL = "https://graphql.brandsolo.com/v1/graphql";

const GET_FOUND_STATS = gql `
query brandSoloQueryFound($client: Int!, $whitelist: [Int!]) {
  found: link_aggregate(
    where: {
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        active: { _eq: 1 }
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
  plan_details(
    where: {
      product: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
    }
  ) {
    plan_aggregate {
      aggregate {
        count
      }
    }
  }
  suspect: link_aggregate(
    where: {
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
      _and: [
        {
          _and: {
            _or: [
              { filter1: { _eq: true }, status: { _eq: 1 } }
              { filter2: { _eq: true }, status: { _eq: 1 } }
              { filter3: { _eq: true }, status: { _eq: 1 } }
              { filter4: { _eq: true }, status: { _eq: 1 } }
              { filter5: { _eq: true }, status: { _eq: 1 } }
              { date_offline: { _is_null: true }, status: { _in: [3] } }
            ]
          }
        }
      ]
      seller_id: { _nin: $whitelist }
    }
  ) {
    aggregate {
      count
    }
  }
}

`;

const GET_INSPECT_STATS = gql `
query brandSoloQueryInspect($client: Int!, $whitelist: [Int!]) {
  suspect: link_aggregate(
    where: {
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
      _and: [
        {
          _and: {
            _or: [
              { filter1: { _eq: true }, status: { _eq: 1 } }
              { filter2: { _eq: true }, status: { _eq: 1 } }
              { filter3: { _eq: true }, status: { _eq: 1 } }
              { filter4: { _eq: true }, status: { _eq: 1 } }
              { filter5: { _eq: true }, status: { _eq: 1 } }
              { date_offline: { _is_null: true }, status: { _in: [3] } }
            ]
          }
        }
      ]
      seller_id: { _nin: $whitelist }
    }
  ) {
    aggregate {
      count
    }
  }
  inspect: link_aggregate(
    where: {
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
      _and: [
        {
          _and: {
            _or: [
              { filter1: { _eq: true }, status: { _eq: 1 } }
              { filter2: { _eq: true }, status: { _eq: 1 } }
              { filter3: { _eq: true }, status: { _eq: 1 } }
              { filter4: { _eq: true }, status: { _eq: 1 } }
              { filter5: { _eq: true }, status: { _eq: 1 } }
              {
                date_offline: { _is_null: true }
                status: { _in: [2, 3, 4, 5, 6] }
              }
            ]
          }
        }
      ]
      seller_id: { _nin: $whitelist }
    }
  ) {
    aggregate {
      count
    }
  }
 
  fake: link_aggregate(
    where: {
      type: { _eq: 1 }
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
      _and: [
        {
          _and: {
            _or: [
              { status: { _in: [5] }, date_offline: { _is_null: true } }
              { status: { _in: [6] } }
            ]
          }
        }
      ]
      seller_id: { _nin: $whitelist }
    }
  ) {
    aggregate {
      count
    }
  }
  grey: link_aggregate(
    where: {
      type: { _eq: 2 }
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
      _and: [
        {
          _and: {
            _or: [
              { status: { _in: [5] }, date_offline: { _is_null: true } }
              { status: { _in: [6] } }
            ]
          }
        }
      ]
      seller_id: { _nin: $whitelist }
    }
  ) {
    aggregate {
      count
    }
  }
}

`;

const GET_TOP_PRODUCT_STATS = gql `
query brandSoloQueryProducts($limit: Int!, $client: Int!, $whitelist: [Int!]) {
  product(
    limit: $limit
    where: {
      _and: [
        {
          _or: [
            { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
            { brand: { client: { demo: { _eq: 1 } } } }
          ]
        }
      ]
      active: { _eq: 1 }
      brand: { client_id: { _eq: $client } }
    }
    order_by: { link_aggregate: { count: desc } }
  ) {
    id
    name
    brand {
      name
    }
    stats: link_aggregate(
      where: {
        _and: [
          {
            _and: {
              _or: [
                { status: { _in: [5] }, date_offline: { _is_null: true } }
                { status: { _in: [6] } }
              ]
            }
          }
        ],
        seller: { id: { _nin: $whitelist } }
        products: {
          _and: [
            {
              _or: [
                { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
                { brand: { client: { demo: { _eq: 1 } } } }
              ]
            }
          ]
          active: { _eq: 1 }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
}

`;

const GET_PLATFORM_STATS = gql `
query brandSoloQueryPlatforms($limit: Int!, $client: Int!, $whitelist: [Int!]) {
  platform(limit: $limit, order_by: { link_aggregate: { count: desc } }) {
    stats: link_aggregate(
      where: {
        _and: [
          {
            _and: {
              _or: [
                { status: { _in: [5] }, date_offline: { _is_null: true } }
                { status: { _in: [6] } }
              ]
            }
          }
        ]
        seller: { id: { _nin: $whitelist } }
        products: {
          _and: [
            {
              _or: [
                { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
                { brand: { client: { demo: { _eq: 1 } } } }
              ]
            }
          ]
          active: { _eq: 1 }
          brand: { client_id: { _eq: $client } }
          
        }
      }
    ) {
      aggregate {
        count
      }
    }
    name
  }
}

`;
const GET_BRAND_STATS = gql `
query brandSoloQueryBrands($client: Int!, $whitelist: [Int!]) {
  brand(
  where: {client_id: {_eq: $client}}) {
    name
    product {
      link_aggregate(where: {_and: [{_or: [{status: {_in: [5]}, date_offline: {_is_null: true}}, {status: {_in: [6]}}]}], products: {_and: [{_or: [{start_date: {_lte: "NOW()"}, end_date: {_gte: "NOW()"}}, {brand: {client: {demo: {_eq: 1}}}}]}], brand: {client_id: {_eq: $client}}, active: {_eq: 1}}}) {
        aggregate {
          count
        }
      }
    }
  }
}


`;
const GET_ACTION_BUCKET_STATS = gql `
query brandSoloQueryActionBucketStats(
  $limit: Int!
  $client: Int!
  $whitelist: [Int!]
) {
  product(
    limit: $limit
    where: { active: { _eq: 1 }, brand: { client_id: { _eq: $client } } }
    order_by: { link_aggregate: { count: desc } }
  ) {
    id
    name
    brand {
      name
    }
    stats: link_aggregate(
      where: {
        date_offline: { _is_null: true }

        products: {
          _and: [
            {
              _or: [
                { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
                { brand: { client: { demo: { _eq: 1 } } } }
              ]
            }
          ]
          brand: { client_id: { _eq: $client } }
          active: { _eq: 1 }
          
        }
        _and: [
          {
            _and: {
              _or: [
                { filter1: { _eq: true }, status: { _eq: 1 } }
                { filter2: { _eq: true }, status: { _eq: 1 } }
                { filter3: { _eq: true }, status: { _eq: 1 } }
                { filter4: { _eq: true }, status: { _eq: 1 } }
                { filter5: { _eq: true }, status: { _eq: 1 } }
              ]
            }
          }
        ]
        seller_id: { _nin: $whitelist }
      }
    ) {
      aggregate {
        count
      }
    }
  }
}

`;

const GET_QUICKVIEW_STATS = gql `
query brandSoloQueryQuickview($client: Int!, $whitelist: [Int!]) {
  action: link_aggregate(
    where: {
      status: { _eq: 1 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
      _and: [
        {
          _or: [
            { filter1: { _eq: true } }
            { filter2: { _eq: true } }
            { filter3: { _eq: true } }
            { filter4: { _eq: true } }
            { filter5: { _eq: true } }
          ]
        }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
  check: link_aggregate(
    where: {
      status: { _eq: 3 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
}

`;

const GET_TOTAL_REMOVED_STATS = gql `
query brandSoloQueryRemoved($client: Int!, $whitelist: [Int!]) {
  fake: link_aggregate(
    where: {
      type: { _eq: 1 }
      products: {
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
        active: { _eq: 1 }
      }
      _and: [
        {
          _and: {
            _or: [
              { status: { _in: [5] }, date_offline: { _is_null: true } }
              { status: { _in: [6] } }
            ]
          }
        }
      ]
      seller_id: { _nin: $whitelist }
    }
  ) {
    aggregate {
      count
    }
  }
  pending: link_aggregate(
    where: {
      status: { _eq: 5 }
      seller: { id: { _nin: $whitelist } }
      date_offline: { _is_null: true }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
  removed: link_aggregate(
    where: {
      status: { _eq: 6 }
      seller: { id: { _nin: $whitelist } }
      date_offline: { _is_null: false }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
  action: link_aggregate(
    where: {
      status: { _eq: 1 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
      _and: [
        {
          _or: [
            { filter1: { _eq: true } }
            { filter2: { _eq: true } }
            { filter3: { _eq: true } }
            { filter4: { _eq: true } }
            { filter5: { _eq: true } }
          ]
        }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
}

`;


const GET_HYGIENE_STATS = gql `
query brandSoloQueryHygiene($client: Int!, $whitelist: [Int!]) {
  action: link_aggregate(
    where: {
      status: { _eq: 1 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
      _and: [
        {
          _or: [
            { filter1: { _eq: true } }
            { filter2: { _eq: true } }
            { filter3: { _eq: true } }
            { filter4: { _eq: true } }
            { filter5: { _eq: true } }
          ]
        }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
  inspect: link_aggregate(
    where: {
      status: { _eq: 2 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
  check: link_aggregate(
    where: {
      status: { _eq: 3 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
  pending: link_aggregate(
    where: {
      status: { _eq: 5 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
  removed: link_aggregate(
    where: {
      status: { _eq: 6 }
      date_offline: { _is_null: true }
      seller: { id: { _nin: $whitelist } }
      products: {
        active: { _eq: 1 }
        _and: [
          {
            _or: [
              { start_date: { _lte: "NOW()" }, end_date: { _gte: "NOW()" } }
              { brand: { client: { demo: { _eq: 1 } } } }
            ]
          }
        ]
        brand: { client_id: { _eq: $client } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
}

`;

const tooltips = {
  found: 'This is what we did for you',
  inspect: 'The bottom line',
  product: 'Top 5 products',
  platform: 'Top 5 platforms',
  total: 'Pending and removed links',
  brand: 'Top 5 brands',
  action: 'Top 5 - Must check links',
  hygiene: 'Are you on track?',
  actions: 'Quick product check'
}


export const MainDashboard = () => {
  const [sellerWhitelist, setSellerWhitelist] = useState(false);
  const [data, setData] = useState(false);

  const user = useSelector((state) => state.auth.user, shallowEqual);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const url = `https://8dxz28uu0g.execute-api.eu-central-1.amazonaws.com/api/client/${user.client.id}`;
      const result = await fetch(url, {
        method: "GET",        
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          'x-api-key': 'GDWFDrsz1F3KquF8WwlIf4iHV6fUWaQSafT3D6A6'
        },
      });

      const data = await result.json();

      setData(data);

      console.log(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <>
      <div id="kt_subheader" class="subheader py-2 py-lg-4 subheader-solid">
        <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          <div className="d-flex align-items-center flex-wrap mr-1">
            <div className="d-flex align-items-baseline mr-5">
              <h5 class="text-dark font-weight-bold my-2 mr-5">Dashboard</h5>
            </div>
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">

            </ul>
          </div>
          <div className="d-flex align-items-center">
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4">
          <FoundWidget type="product" tooltip={tooltips.found} client={user.client.id} whitelist={sellerWhitelist} query={data} title="Effort" subtile={tooltips.found} className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4">
          <ListsWidget type="top_products_action_bin" tooltip={tooltips.action} client={user.client.id} whitelist={sellerWhitelist} query={data} title="Top product action bins" subtile={tooltips.action} className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4">
          <MixedWidget type="total" tooltip={tooltips.total} client={user.client.id} whitelist={sellerWhitelist} query={data} title="Removal percentage" subtile={tooltips.total} className="card-stretch gutter-b" />
        </div>
      </div>
      {/*
      <div className="row">
        <div className="col-lg-4">
          <ListsWidget type="product" tooltip={tooltips.action} client={user.client.id} whitelist={sellerWhitelist} query={GET_ACTION_BUCKET_STATS} title="Action Bins" subtile={tooltips.action} className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4">
          <QuickViewWidget type="product" tooltip={tooltips.quickview} client={user.client.id} whitelist={sellerWhitelist} query={GET_QUICKVIEW_STATS} title="Actions" subtile={tooltips.quickview} className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4">
          <MixedWidget type="hygiene" tooltip={tooltips.hygiene} client={user.client.id} whitelist={sellerWhitelist} query={GET_HYGIENE_STATS} title="Hygiene" subtile={tooltips.hygiene} className="card-stretch gutter-b" />
        </div>
      </div>
      */}

      <div className="row">
        <div className="col-lg-4">
          <ListsWidget type="top_counterfeit_products" tooltip={tooltips.product} client={user.client.id} whitelist={sellerWhitelist} query={data} title="Top counterfeit products" subtile={tooltips.product} className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4">
          <ListsWidget type="top_counterfeit_platforms" tooltip={tooltips.platform} client={user.client.id} whitelist={sellerWhitelist} query={data} title="Top counterfeit platforms" subtile={tooltips.platform} className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4">
          <BrandWidget type="top_counterfeit_brands" tooltip={tooltips.brand} client={user.client.id} whitelist={sellerWhitelist} query={data} title="Top counterfeit brands" subtile={tooltips.brand} className="card-stretch gutter-b" />
        </div>
      </div>
    </>
  );

}